import { render } from "./ChatbotHome.vue?vue&type=template&id=df0057d4&scoped=true"
import script from "./ChatbotHome.vue?vue&type=script&lang=js"
export * from "./ChatbotHome.vue?vue&type=script&lang=js"

import "./ChatbotHome.vue?vue&type=style&index=0&id=df0057d4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/chatbot/chatbot_web/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0057d4"]])

export default __exports__